import { render, staticRenderFns } from "./PortailAccueilTab.vue?vue&type=template&id=0c45bc72&scoped=true&"
import script from "./PortailAccueilTab.vue?vue&type=script&lang=js&"
export * from "./PortailAccueilTab.vue?vue&type=script&lang=js&"
import style0 from "./PortailAccueilTab.vue?vue&type=style&index=0&id=0c45bc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45bc72",
  null
  
)

export default component.exports